module.exports = __webpack_public_path__ + "static/media/exist-food.309fbdd0.png";